import React from "react";

export function ButtonUp(){
    return(
        <>
            <a href="/#" className="btn btn-lg btn-primary btn-lg-square back-to-top" style={{display: 'inline-block'}}><i className="fa fa-angle-double-up"></i></a>
        </>
    );
}